import { Link } from "react-router-dom";
import logoImg from "@/assets/logo-hitchef.png";

const HeroSection = () => {
  return (
    <section className="relative pt-28 pb-14 sm:pt-32 sm:pb-20 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 70% 60% at 50% 35%, hsla(220, 60%, 85%, 0.3) 0%, hsla(260, 40%, 90%, 0.12) 40%, transparent 70%)',
        }}
      />

      <div className="max-w-[1150px] mx-auto px-4 text-center relative z-10">
        <div className="max-w-3xl mx-auto">
          <div className="flex justify-center mb-10 sm:mb-12">
            <div
              className="relative animate-fade-in"
              style={{ animation: 'hero-logo-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards' }}
            >
              <div className="absolute -inset-6 rounded-full bg-gradient-to-br from-primary/15 to-[#a78bfa]/10 blur-2xl" />
              <img
                src={logoImg}
                alt="Хит Шеф — песня на заказ за 3 минуты"
                className="relative w-24 h-24 sm:w-28 sm:h-28 rounded-2xl object-cover"
                style={{
                  boxShadow: '0 8px 30px hsla(220, 60%, 50%, 0.12), 0 2px 8px hsla(0, 0%, 0%, 0.06)',
                }}
                width={112}
                height={112}
                loading="eager"
                fetchPriority="high"
                decoding="async"
              />
            </div>
          </div>

          <h1 className="font-display text-3xl sm:text-4xl md:text-[2.75rem] lg:text-5xl font-bold tracking-tight leading-[1.15] animate-slide-up text-foreground mb-6">
            Песня на заказ —{" "}
            <span className="bg-gradient-to-r from-primary to-[#a78bfa] bg-clip-text text-transparent">
              за 3 минуты
            </span>
          </h1>

          <div className="space-y-2 animate-slide-up [animation-delay:100ms] mb-8">
            <p className="text-lg sm:text-xl text-foreground/80 max-w-xl mx-auto leading-relaxed">
              Расскажите свою историю — мы превратим её в&nbsp;песню, которая тронет до&nbsp;мурашек.
            </p>
            <p className="text-sm sm:text-base text-muted-foreground max-w-md mx-auto">
              Идеально для дня рождения, признания или сюрприза близкому.
            </p>
          </div>

          <div className="flex flex-col items-center gap-3 pt-2 animate-slide-up [animation-delay:200ms] mb-6">
            <Link
              to="/create"
              className="w-full max-w-xs flex items-center justify-center gap-2 h-14 rounded-2xl text-lg font-bold text-primary-foreground bg-primary hover:bg-primary/90 hover:scale-[1.02] hover:shadow-xl hover:shadow-primary/25 active:scale-[0.97] transition-all duration-200 shadow-lg shadow-primary/30"
            >
              🔥 Создать песню
            </Link>
            <p className="text-sm text-muted-foreground">
              Демо бесплатно. Без установки приложений.
            </p>
          </div>

          <div className="animate-slide-up [animation-delay:300ms]">
            <p className="inline-flex items-center gap-2 text-sm text-muted-foreground">
              <span>⭐</span>
              <span className="font-display font-semibold text-foreground/70">12 000+</span>
              <span>песен создано</span>
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes hero-logo-in {
          from { opacity: 0; transform: scale(0.98); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
